/**
 * Intents - what the players mean to do, queued for the GM.
 *
 * - `IntentBox` (a player, in a phase with no turn order): a line to type
 *   and send, and under it what they have already sent and the GM has not
 *   yet dealt with, each of which they may withdraw.
 * - The GM's queue is a row per intent in the asks tray since v9.5.3
 *   (`components/asks/rows.jsx`); Done takes it off both screens.
 *
 * An intent is a sentence: nothing is rolled or resolved by sending it.
 */
import { useState } from 'react';
import common from '../../styles/common.module.css';
import styles from '../../styles/CallForTest.module.css';
import story from '../../styles/Story.module.css';
import { INTENT_ASK, MAX_INTENT, intentOf, intentsIn } from '../../engine/narrative/intents';

/**
 * @param {object} props
 * @param {import('../../hooks/useAsks').Asks} props.asks
 * @param {string} props.name - who is speaking: the character acted as, else the player
 */
export function IntentBox({ asks, name }) {
  const [text, setText] = useState('');
  const mine = intentsIn(asks.outgoing);
  const send = (e) => {
    e.preventDefault();
    const intent = intentOf(text, name);
    if (!intent) return;
    asks.ask(INTENT_ASK, 'gm', intent);
    setText('');
  };
  return (
    <div className={styles.calls} data-testid="intent-box">
      <form className={story.form} onSubmit={send}>
        <label className={story.field}>
          What do you do?
          <input
            className={story.input}
            data-testid="intent-input"
            value={text}
            maxLength={MAX_INTENT}
            onChange={(e) => setText(e.target.value)}
          />
        </label>
        <button type="submit" className={common.btnSmall} data-testid="intent-send" disabled={!text.trim()}>
          Tell the GM
        </button>
      </form>
      {mine.map(({ id, intent }) => (
        <div key={id} className={styles.callLine} data-testid="intent-mine">
          <span>Waiting on the GM: {intent.text}</span>
          <button type="button" className={common.btnSmall} onClick={() => asks.cancel(id)}>
            Withdraw
          </button>
        </div>
      ))}
    </div>
  );
}

/**
 * @param {object} props
 * @param {import('../../hooks/useAsks').Asks} props.asks
 */
